import React, { useRef } from 'react';
import { useStoreon } from 'storeon/react';
import { useRegionIdSelector } from 'modules/model-json';
import { SERVICES_STORE_NAME } from 'modules/services';
import { State } from 'store/types';
import { FilterSystems } from './filter-systems';
import { HeatingSystems } from './heating-systems';
import { MainPage } from './main-page';
import { PowerSupplySystems } from './power-supply-systems';
import { SewerageSystems } from './sewerage-systems';
import { VentilationSystems } from './ventilation-systems';
import { EngineeringSystemsTypes } from './engineering-systems-enums';
import { EngineeringSystemTypeProps } from './engineering-systems-types';

type EngineeringSystemsProps = {
  system: EngineeringSystemsTypes;
};

const ENGINEERING_SYSTEMS_TYPES_MAP: Record<
  EngineeringSystemsTypes,
  React.FC<EngineeringSystemTypeProps>
> = {
  [EngineeringSystemsTypes.Default]: MainPage,
  [EngineeringSystemsTypes.Filter]: FilterSystems,
  [EngineeringSystemsTypes.Heating]: HeatingSystems,
  [EngineeringSystemsTypes.PowerSupply]: PowerSupplySystems,
  [EngineeringSystemsTypes.Sewerage]: SewerageSystems,
  [EngineeringSystemsTypes.Ventilation]: VentilationSystems,
};

/**
 * Компонент отображения страниц "Инженерные системы"
 */
export const EngineeringSystems = ({ system }: EngineeringSystemsProps) => {
  const consultationSectionRef = useRef<HTMLElement | null>(null);
  const { services } = useStoreon<State>(SERVICES_STORE_NAME);
  const regionId = useRegionIdSelector();
  const serviceTypePrice = services?.servicePrice;
  const Component = ENGINEERING_SYSTEMS_TYPES_MAP[system];

  /**
   * Обработчик нажатия на кнопку "Записаться на консультацию"
   */
  const handleConsultationSignupBtnClick = () => {
    consultationSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Component
      consultationSectionRef={(el: HTMLElement | null) => {
        consultationSectionRef.current = el;
      }}
      onConsultationSignupBtnClick={handleConsultationSignupBtnClick}
      regionId={regionId}
      serviceTypePrice={serviceTypePrice}
    />
  );
};
